export default __webpack_public_path__ + "static/media/PR_anymedi 3.284def02.png";